import { QueryClient } from '@tanstack/react-query';
import { PostgrestError } from '@supabase/supabase-js';

export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes
        refetchOnWindowFocus: typeof process !== 'undefined' && process.env.NODE_ENV === 'production',
        retry: (failureCount, error) => {
          // Don't retry on 404s and authorization errors
          if (
            error instanceof PostgrestError && 
            (error.code === '404' || error.code === '403' || error.code === '401')
          ) {
            return false;
          }
          return failureCount < 3;
        },
      },
      mutations: {
        retry: false,
        onError: (error) => {
          console.error('Mutation error:', error);
        }
      }
    },
  });
} 